import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption text-warning mr-3 tp-approver__dirty"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_4 = { class: "d-flex align-center ga-2 flex-nowrap" }
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-error mt-1"
}
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "tp-approver__intro" }, [
        _createElementVNode("div", { class: "text-subtitle-1" }, "承認者・提出期限"),
        _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, " 帳票種別とクラスの組み合わせごとに承認者と提出期限を決めます。クラスを「全クラス共通」にすると、 個別設定のないクラスに適用されます。最終承認者を「設定しない」にすると一段階承認になります。 ")
      ], -1)),
      _createVNode(_component_v_spacer),
      (_ctx.isDirty)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_component_v_icon, { size: "14" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-circle-medium", -1)
              ]))]),
              _: 1
            }),
            _cache[1] || (_cache[1] = _createTextVNode(" 未保存の変更があります ", -1))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_btn, {
        class: "mr-2",
        variant: "outlined",
        color: "primary",
        disabled: _ctx.loading || _ctx.loadFailed,
        onClick: _ctx.addRow
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" 設定を追加 ", -1))
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        loading: _ctx.saving,
        disabled: !_ctx.isValid || _ctx.loading || _ctx.loadFailed,
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" 保存する ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ]),
    (_ctx.duplicatedKeys.length > 0)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "warning",
          variant: "tonal",
          density: "compact",
          class: "mt-3"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" 同じ帳票種別・クラスの設定が重複しています。1つにまとめてください。 ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (_ctx.loadFailed)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 2,
            type: "error",
            variant: "tonal",
            density: "compact",
            class: "mt-3"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_btn, {
                size: "small",
                variant: "outlined",
                onClick: _ctx.load
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("再読み込み", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createTextVNode(" 承認者・提出期限の設定を読み込めませんでした。通信状況を確認して、もう一度お試しください。 ", -1))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_table, {
            key: 3,
            density: "compact",
            class: "mt-3 tp-approver__table"
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "帳票種別"),
                  _createElementVNode("th", null, "クラス"),
                  _createElementVNode("th", null, "一次承認者"),
                  _createElementVNode("th", null, "最終承認者"),
                  _createElementVNode("th", null, "提出期限"),
                  _createElementVNode("th")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_select, {
                        modelValue: row.planType,
                        "onUpdate:modelValue": [($event: any) => ((row.planType) = $event), ($event: any) => (_ctx.onPlanTypeChange(row))],
                        items: _ctx.createPlanTypeItems,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        color: "primary",
                        style: {"flex":"none","width":"150px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_select, {
                        modelValue: row.classId,
                        "onUpdate:modelValue": ($event: any) => ((row.classId) = $event),
                        items: _ctx.classItemsFor(row.planType),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        color: "primary",
                        disabled: row.planType === 'overall',
                        style: {"flex":"none","width":"220px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_select, {
                        modelValue: row.firstApproverId,
                        "onUpdate:modelValue": ($event: any) => ((row.firstApproverId) = $event),
                        items: _ctx.approverItems,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        color: "primary",
                        "no-data-text": "主任以上のスタッフがいません",
                        style: {"flex":"none","width":"150px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_select, {
                        modelValue: row.finalApproverId,
                        "onUpdate:modelValue": ($event: any) => ((row.finalApproverId) = $event),
                        items: _ctx.finalApproverItems,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        color: "primary",
                        style: {"flex":"none","width":"150px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_select, {
                          modelValue: row.deadlineKind,
                          "onUpdate:modelValue": ($event: any) => ((row.deadlineKind) = $event),
                          items: _ctx.deadlineKindItemsFor(row.planType),
                          variant: "outlined",
                          density: "compact",
                          "hide-details": "",
                          color: "primary",
                          style: {"flex":"none","width":"150px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                        (row.deadlineKind === 'dayOfPreviousMonth')
                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 0,
                              modelValue: row.deadlineDay,
                              "onUpdate:modelValue": ($event: any) => ((row.deadlineDay) = $event),
                              modelModifiers: { number: true },
                              type: "number",
                              min: "1",
                              max: "28",
                              suffix: "日",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              style: {"flex":"none","width":"95px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true),
                        (row.deadlineKind === 'weekdayOfPreviousWeek')
                          ? (_openBlock(), _createBlock(_component_v_select, {
                              key: 1,
                              modelValue: row.deadlineWeekday,
                              "onUpdate:modelValue": ($event: any) => ((row.deadlineWeekday) = $event),
                              items: _ctx.weekdayItems,
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              style: {"flex":"none","width":"120px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]))
                          : _createCommentVNode("", true),
                        (row.deadlineKind === 'fixedDate')
                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 2,
                              modelValue: row.deadlineMonthDay,
                              "onUpdate:modelValue": ($event: any) => ((row.deadlineMonthDay) = $event),
                              placeholder: "MM-DD",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              style: {"flex":"none","width":"110px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.deadlineError(row))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.deadlineError(row)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_6, [
                      _createVNode(_component_v_btn, {
                        size: "x-small",
                        variant: "text",
                        color: "error",
                        onClick: ($event: any) => (_ctx.removeRow(index))
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" 削除 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                }), 128)),
                (_ctx.rows.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("td", {
                        colspan: "6",
                        class: "text-center text-grey py-6"
                      }, " 承認者が設定されていません。設定するまで指導計画を提出できません。 ", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
  ]))
}